export default {"src":"/_next/static/media/integrations-2.6918a2bf.svg","height":121,"width":101,"blurWidth":0,"blurHeight":0};